import { InjectionToken, Type } from '@angular/core';
import { BaseBubbleComponent } from '../classes';

export const BUBBLE_REGISTRATIONS: InjectionToken<Map<string, Type<BaseBubbleComponent>>> = new InjectionToken('BUBBLE_REGISTRATIONS');
